<style scoped lang="scss" type="text/scss">
    .introduce-container {
        .submit-buttons {
            margin-top: 1rem;
        }
    }
</style>

<template>
    <div class="introduce-container">
        <block-divider>队伍简介（ 最多 500 字 ）</block-divider>
        <el-input
                class="full-width"
                clearable
                type="textarea"
                :rows="12"
                placeholder="请输入内容"
                v-model="introduce">
        </el-input>
      <block-divider>队伍历史（ 最多 1000 字 ）</block-divider>
      <el-input
          class="full-width"
          clearable
          type="textarea"
          :rows="12"
          placeholder="请输入内容"
          v-model="introduce2">
      </el-input>
      <block-divider>历届突出成绩（ 最多 1000 字 ）</block-divider>
      <el-input
          class="full-width"
          clearable
          type="textarea"
          :rows="12"
          placeholder="请输入内容"
          v-model="introduce3">
      </el-input>
      <block-divider>团队组成（ 最多 1000 字 ）</block-divider>
      <el-input
          class="full-width"
          clearable
          type="textarea"
          :rows="12"
          placeholder="请输入内容"
          v-model="introduce4">
      </el-input>
      <block-divider>一点感悟的话（ 最多 200 字 ）</block-divider>
      <el-input
          class="full-width"
          clearable
          type="textarea"
          :rows="12"
          placeholder="请输入内容"
          v-model="introduce5">
      </el-input>
      <block-divider>上场队员信息（ 最多 600 字 ）</block-divider>
      <el-input
          class="full-width"
          clearable
          type="textarea"
          :rows="12"
          placeholder="请输入内容"
          v-model="introduce6">
      </el-input>


        <div class="submit-buttons">
            <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
<!--            <el-button @click="reset()">重置</el-button>-->
        </div>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';

    export default {
        name: '',
        components: {
            BlockDivider
        },
        data () {
            return {
                MAX_LENGTH: 1000,
                introduce: null,
                introduce2: null,
                introduce3: null,
                introduce4: null,
                introduce5: null,
                introduce6: null,
                requesting: false,
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            },
            currentManagedPlayerInfo () {
                return this.$store.state.player.currentManagedPlayerInfo;
            }
        },
        watch: {
            currentManagedPlayerInfo: {
                immediate: true,
                handler (info) {
                    this.introduce = info.introduce;
                    this.introduce2 = info.introduce2;
                    this.introduce3 = info.introduce3;
                    this.introduce4 = info.introduce4;
                    this.introduce5 = info.introduce5;
                    this.introduce6 = info.introduce6;
                }
            }
        },
        methods: {
            update () {
                const introduce = this.introduce;
                const introduce2 = this.introduce2;
                const introduce3 = this.introduce3;
                const introduce4 = this.introduce4;
                const introduce5 = this.introduce5;
                const introduce6 = this.introduce6;

                if (introduce === null || introduce.length === 0) {
                    this.$tip('队伍简介不能为空');
                    return;
                }
                if(introduce2 === null || introduce2.length === 0 ){
                  this.$tip("队伍历史不能为空");
                  return;
                }
              if(introduce3 === null || introduce3.length === 0 ){
                this.$tip("历届突出成绩不能为空");
                return;
              }
              if(introduce4 === null || introduce4.length === 0 ){
                this.$tip("团队组成不能为空");
                return;
              }
              if(introduce5 === null || introduce5.length === 0 ){
                this.$tip("请填写感悟的话");
                return;
              }
              if(introduce6 === null || introduce6.length === 0 ){
                this.$tip("上场队员信息不能为空");
                return;
              }
                if (introduce.length > this.MAX_LENGTH) {
                    this.$tip(`参赛介绍不能不能超过 ${this.MAX_LENGTH} 字，当前为 ${introduce.length} 字`);
                    return;
                }
                this.$normalRequest('player/updateIntroduce', {
                    id: this.currentManagedPlayerId,
                    introduce: introduce,
                    introduce2: introduce2,
                    introduce3: introduce3,
                    introduce4: introduce4,
                    introduce5: introduce5,
                    introduce6: introduce6
                }, '解说基础信息更新成功', true, this, 'requesting').then(_ => {
                    this.$store.dispatch('player/loadRegistrableManagedPlayerInfo').then();
                }).catch(_ => {
                });
            },
            reset () {
                this.introduce = this.currentManagedPlayerInfo.introduce;


            }
        }
    };
</script>
